/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { createMatrixClass } from '../../factoriesAny.js';
export var MatrixDependencies = {
  createMatrixClass
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesMatrixClass.generated.js
// module id = 265
// module chunks = 2